<script>
    import ModellApi from '../modell-api'
    import { AjaxRenderingEngine } from '@scripts/ajax-render-engine';
    export default {
        data: function () {
            return {
                items: [],                
                loading: true,
                isAjaxEngineReady: false,
                isVisible: false
            };
        },

        computed: {
            
        },

        created: function () {

        },
        mounted: function () {
            if (!this.isAjaxEngineReady) {
                const formHead = document.querySelector('head');
                formHead.addEventListener('readyForGtm', this.onAjaxRenderEngineReady.bind(this), false);
            }
            var plidEl = jQuery("#plid");
            var id = plidEl.data("plid");

            ModellApi.getIsAccessoryToList(id).then((response) => {
                if (response.data != null ) {
                    this.items = response.data;
                    this.isVisible = response.data.length > 0;
                    var hideClass = this.$parent.hideClass;
                    if (hideClass.length <= 0)
                        retur;
                    hideClass = "." + hideClass;

                    if (!this.isVisible) {
                        jQuery(hideClass).hide();
                        jQuery(hideClass).hide();

                    }
                    else {
                        jQuery(hideClass).show();
                        jQuery(hideClass).show();
                    }
                }
            })
            .finally(() => {
                this.loading = false;
            });

        },
        methods: {
            onAjaxRenderEngineReady: function () {
                this.isAjaxEngineReady = true;
            }
        }
    }
</script>

<template>
    <table class="gprod" v-if="isVisible">
        <thead>
            <tr>
                <th>{{ $t('Modellregister.Brand') }}</th>
                <th>{{ $t('Modellregister.Model') }}</th>
                <th>{{ $t('Modellregister.From') }}</th>
                <th>{{ $t('Modellregister.To') }}</th>
                <th>{{ $t('Modellregister.OpenTextField') }}</th>
            </tr>
        </thead>
        <tbody>
            <template v-for="item in items">
                <tr>
                    <td>{{item.Brand}}</td>
                    <td>{{item.Model}}</td>
                    <td>{{item.From}}</td>
                    <td>{{item.To}}</td>
                    <td>{{item.OpenTextField}}</td>
                </tr>                
            </template>
        </tbody>
    </table>
</template>
